import { GridColDef } from '@mui/x-data-grid';
import { States } from 'utils/Enums';

export const RegionalsTableColumns: GridColDef[] = [
  { field: 'id', headerName: 'ID', hide: true },
  {
    field: 'city',
    headerName: 'Cidade',
    width: 200
  },
  {
    field: 'uf',
    headerName: 'Estado',
    width: 200,
    valueFormatter: ({ value }) => States[String(value)]
  },
  {
    field: 'regional',
    headerName: 'Regional',
    width: 80,
    minWidth: 80,
    flex: 1
  }
];
